import React,{Component} from 'react'
import FrameComponents from '../FrameComponents';
import './index.css'
class dashboard extends Component {
  state = {
    refData:''
  }
  // 进入组件调用
  componentDidMount() {
    // 设置页面标题
    document.title = 'DropshipMan-subscribe';
    let shopify = window?.shopify;  
    if (shopify) {
      window.addEventListener('message', this.handleDataFromMainApp);
      }
  }
   // 接收数据
   handleDataFromMainApp = (ev) => {
    const _that = ev.data;
    const _type = _that?.mode || '';
    
    if (_type === 'set_modal') {
      if (_that?.params?.ref === "sourcing_id" || _that?.params?.ref === "import_id") {
        this.setState({
          refData: _that?.params?.ref
        })
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener('message', this.handleDataFromMainApp);
  }
  
 
  render() {
   console.log(this.state.refData);
   
    return (
      <div>
        <FrameComponents name="subscribe" refData={this.state.refData}/> 
      </div>
    );
    
  }
}

export default dashboard;

